import React from 'react';
import { ClipLoader } from 'react-spinners';
import './AuthLoading.css';

const AuthLoading = () => (
  <div className="auth-page">
    <ClipLoader sizeUnit={'px'} size={150} color={'#009b65'} />
  </div>
);

export default AuthLoading;
